import React from "react";

export default function StepAgent({ profile, onEdit }) {
  if (!profile) return <div>Loading…</div>;
  const rows = [
    ["Agency", profile.agency_name],
    ["Address", profile.address],
    ["Phone", profile.contact_numbers],
    ["Email", profile.email],
    ["Website", profile.website],
    ["GST", profile.gst_number],
  ];
  return (
    <div>
      <p className="text-sm text-slate-500">These details will appear on every quotation. Update them from your profile.</p>
      <div className="mt-5 flex items-start gap-6">
        {profile.logo_url && <img src={profile.logo_url} alt="logo" className="h-20 w-auto border border-border p-2 rounded" />}
        <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-sm">
          {rows.map(([k, v]) => (
            <div key={k}><div className="overline text-[9px]">{k}</div><div className="mt-0.5">{v || "—"}</div></div>
          ))}
        </div>
      </div>
      <button data-testid="edit-profile-link" onClick={onEdit} className="mt-6 text-xs text-[#16A34A] uppercase tracking-widest">Edit profile →</button>
    </div>
  );
}
